module.exports = __webpack_public_path__ + "img/C07TechSpearmanChampion_ua.9b6148f2.webp";